import { useTranslation } from "react-i18next";
import { usePlatformStatus } from "../../utils/platformStatus";

const COLORS = {
    green: '#22c55e',
    yellow: '#eab308',
    red: '#ef4444',
    unknown: '#94a3b8',
} as const;

// Performance-Ampel in der Topbar (Masterplan Paket 7, ersetzt das Coins-Widget). Reine
// Plattform-Info, keine App-Daten - legitim im Plattform-Rahmen (Container-Prinzip, CLAUDE.md).
export const PlatformStatusIndicator = () => {
    const { t } = useTranslation('common');
    const signal = usePlatformStatus();
    const level = signal?.level ?? 'unknown';
    const summary = t(`status.${level}`);
    const reason = signal?.reasonKey ? t(signal.reasonKey) : null;
    const label = `${t('status.label')}: ${summary}${reason ? ` – ${reason}` : ''}`;

    return (
        <div
            role="status"
            data-tour="platform-status"
            aria-label={label}
            title={label}
            className="d-flex align-items-center justify-content-center"
            style={{ width: 32, height: 32 }}
        >
            <span
                style={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: COLORS[level],
                    boxShadow: `0 0 0 3px ${COLORS[level]}33`,
                    transition: 'background-color 0.3s ease',
                }}
            />
        </div>
    );
};
